import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import Loader from "../components/Loader";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";

const AccountSettings = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [postCount, setPostCount] = useState(0);
  const [newPass, setNewPass] = useState(false);
  const [oldPass, setOldPass] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [formValue, setFormValue] = useState({
    oldPass: "",
    newPass: "",
  });
  const [info, setInfo] = useState({
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
  });
  const [error, setError] = useState({});

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const getPostsList = await axiosHttp.get(`post-data?page=1&type=post`);
      if (getPostsList.status === 200) {
        let data = getPostsList?.data?.meta?.total;
        setPostCount(data);
        fetchBankDetails();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  const fetchBankDetails = async () => {
    try {
      const getBankDetails = await axiosHttp.get("stripe/bank-account");
      if (getBankDetails.status === 200) {
        let data = getBankDetails?.data?.data;
        setInfo(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };
  const handleChange = (e) => {
    setErrMsg("");
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleAccountChange = (e) => {
    const { name, value } = e.target;
    if (name === "account_number") {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
      setInfo({ ...info, account_number: e.target.value });
    } else {
      setInfo({ ...info, [name]: value });
    }
    setError({ ...error, [name]: "" });
  };

  const formValidation = () => {
    let isValid = true;
    if (info.account_holder_name === null || info.account_holder_name === "") {
      isValid = false;
      setError({
        ...error,
        account_holder_name: "Account holder name required",
      });
    } else if (info.account_holder_name.trim().length < 3) {
      isValid = false;
      setError({ ...error, account_holder_name: "Enter minimum 3 characters" });
    } else if (info.account_number === null || info.account_number === "") {
      isValid = false;
      setError({ ...error, account_number: "Account number required" });
    } else if (info.ifsc_code === null || info.ifsc_code === "") {
      isValid = false;
      setError({ ...error, ifsc_code: "IFSC required" });
    }
    if (isValid) {
      handleBankSubmit();
    } else {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Please fill the required fields",
      });
    }
  };

  const handleBankSubmit = async () => {
    setLoading(true);
    try {
      const addBankDetails = await axiosHttp.post("stripe/bank-account", info);
      if (addBankDetails.status === 201) {
        appContext.updateNotificationState({
          show: true,
          message: "Bank details updated successfully",
          type: "success",
        });
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handleSubmit = () => {
    const passwordPattern =
      // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#^$%!])[A-Za-z\d@#^$%!]{8,}$/;

    if (!passwordPattern.test(formValue?.newPass)) {
      setErrMsg(
        "New Password must be 8 characters and include at least one lowercase letter, one uppercase letter, one number, and one special character"
      );
    } else if (formValue?.oldPass.trim().length < 8) {
      setErrMsg(
        "Old Password must be 8 characters and include at least one lowercase letter, one uppercase letter, one number, and one special character"
      );
    } else if (formValue?.newPass === formValue?.oldPass) {
      setErrMsg("Old Password cannot be the new password");
    } else {
      changePasswordHandler();
    }
  };

  const changePasswordHandler = async () => {
    setLoading(true);
    let payload = {
      oldPassword: btoa(formValue?.oldPass),
      newPassword: btoa(formValue?.newPass),
    };
    try {
      const submitDetails = await axiosHttp.post("change-password", payload);
      if (submitDetails.status === 202) {
        authContext.logout();
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        setLoading(false);
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(error),
        type: "error",
      });
      setLoading(false);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="card card-one-1 margin">
      <div className="card-body">
        <p className="title">Account Settings</p>

        <div className="row">
          <div className="col-md-6">
            <p className="title">Password</p>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-md-6">
            <div className="mb-3">
              <label>New Password</label>
              <div className="input-group flex-gp">
                <input
                  type={newPass ? "text" : "password"}
                  className="form-control"
                  id=""
                  placeholder=""
                  value={formValue?.newPass}
                  onChange={handleChange}
                  name="newPass"
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text bg-white toggle-password"
                    onClick={() => setNewPass((prev) => !!!prev)}
                  >
                    {newPass ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                      >
                        <path
                          d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                          fill="#ABABAB"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_23_60)">
                          <path
                            d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                            fill="#ABABAB"
                          />
                          <path
                            d="M6.99843 3.50074C8.75439 3.50074 10.1795 4.92588 10.1795 6.68184C10.1795 7.09221 10.0968 7.48348 9.95369 7.84293L11.8146 9.70388C12.7753 8.90224 13.5324 7.86521 14 6.68184C12.8962 3.88885 10.1827 1.9102 6.99846 1.9102C6.10774 1.9102 5.25523 2.06925 4.46313 2.35555L5.83737 3.72659C6.19679 3.58663 6.58807 3.50074 6.99843 3.50074Z"
                            fill="#ABABAB"
                          />
                          <path
                            d="M0.636209 1.7671L2.08679 3.21768L2.37628 3.50717C1.32652 4.3279 0.496251 5.41902 0 6.6819C1.10067 9.47489 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955925L0.636209 1.7671ZM4.15452 5.28222L5.13748 6.26518C5.10885 6.40198 5.08976 6.53875 5.08976 6.6819C5.08976 7.73485 5.94547 8.59055 6.99842 8.59055C7.14157 8.59055 7.27837 8.57147 7.41197 8.54284L8.39493 9.52579C7.97183 9.73575 7.50105 9.863 6.99842 9.863C5.24245 9.863 3.81731 8.43786 3.81731 6.6819C3.81731 6.17929 3.94457 5.70848 4.15452 5.28222Z"
                            fill="#ABABAB"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_23_60">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label>Current Password</label>
              <div className="input-group flex-gp">
                <input
                  type={oldPass ? "text" : "password"}
                  className="form-control"
                  id=""
                  placeholder=""
                  value={formValue?.oldPass}
                  onChange={handleChange}
                  name="oldPass"
                />
                <div className="input-group-append">
                  <span
                    className="input-group-text bg-white toggle-password"
                    onClick={() => setOldPass((prev) => !!!prev)}
                  >
                    {oldPass ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                      >
                        <path
                          d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                          fill="#ABABAB"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_23_60)">
                          <path
                            d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                            fill="#ABABAB"
                          />
                          <path
                            d="M6.99843 3.50074C8.75439 3.50074 10.1795 4.92588 10.1795 6.68184C10.1795 7.09221 10.0968 7.48348 9.95369 7.84293L11.8146 9.70388C12.7753 8.90224 13.5324 7.86521 14 6.68184C12.8962 3.88885 10.1827 1.9102 6.99846 1.9102C6.10774 1.9102 5.25523 2.06925 4.46313 2.35555L5.83737 3.72659C6.19679 3.58663 6.58807 3.50074 6.99843 3.50074Z"
                            fill="#ABABAB"
                          />
                          <path
                            d="M0.636209 1.7671L2.08679 3.21768L2.37628 3.50717C1.32652 4.3279 0.496251 5.41902 0 6.6819C1.10067 9.47489 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955925L0.636209 1.7671ZM4.15452 5.28222L5.13748 6.26518C5.10885 6.40198 5.08976 6.53875 5.08976 6.6819C5.08976 7.73485 5.94547 8.59055 6.99842 8.59055C7.14157 8.59055 7.27837 8.57147 7.41197 8.54284L8.39493 9.52579C7.97183 9.73575 7.50105 9.863 6.99842 9.863C5.24245 9.863 3.81731 8.43786 3.81731 6.6819C3.81731 6.17929 3.94457 5.70848 4.15452 5.28222Z"
                            fill="#ABABAB"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_23_60">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-md-12 mt-3">
            <p>
              can't remember your current password?{" "}
              <a href="">
                <u>Reset your password</u>
              </a>
            </p>
          </div> */}
          <div className="col-md-12">
            {errMsg !== "" && <p className="error">{errMsg}</p>}
          </div>
          <div className="col-md-6 mt-3">
            <button
              type="button"
              className="btn btn-primary prim-btn"
              onClick={handleSubmit}
            >
              Save Password
            </button>
          </div>
        </div>
        <hr />
        {/* <p className="title">Bank Details </p> */}
        {/* <div className="row mb-4">
          <div className="col-md-6">
            <div className="mb-3">
              <label>Account Holder Name</label>
              <div className="input-group flex-gp">
                <input
                  className="form-control py-4"
                  type="text"
                  name="account_holder_name"
                  value={info?.account_holder_name || ""}
                  onChange={(e) => handleAccountChange(e)}
                />
              </div>
              {error?.account_holder_name && (
                <p className="field-error">{error?.account_holder_name}</p>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label>Account Number</label>
              <div className="input-group flex-gp">
                <input
                  className="form-control py-4"
                  type="text"
                  name="account_number"
                  value={info?.account_number || ""}
                  onChange={(e) => handleAccountChange(e)}
                  pattern="[0-9]*"
                />
              </div>
              {error?.account_number && (
                <p className="field-error">{error?.account_number}</p>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label>IFSC Code</label>
              <div className="input-group flex-gp">
                <input
                  className="form-control py-4"
                  type="text"
                  name="ifsc_code"
                  value={info?.ifsc_code || ""}
                  onChange={(e) => handleAccountChange(e)}
                />
              </div>
            </div>
            {error?.ifsc_code && (
              <p className="field-error">{error?.ifsc_code}</p>
            )}
          </div>
          <div className="col-md-12 mt-3">
            <button
              type="button"
              className="btn btn-primary prim-btn"
              onClick={formValidation}
            >
              Save
            </button>
          </div>
        </div> */}
        {/* <hr /> */}
        <p className="title">Delete Account</p>
        <div className="row mt-4">
          <div className="col-md-12">
            <p>
              Would you like to delete your account?
              <br />
              This account contains{" "}
              {postCount <= 1
                ? `${postCount} post.`
                : `${postCount} posts.`}{" "}
              Deleting your account will remove all the content associated with
              it.
            </p>
            <p
              className="mt-3 text-danger "
              onClick={() =>
                appContext.updateModalType("deleteAccount", "Delete Account")
              }
            >
              <u className="cursor-pointer">I want to delete my account</u>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
